import { Table, ConfigProvider } from "antd";

const FIELDS = [
  {
    key: "name",
    name: "Сотрудник",
  },
  {
    key: "position_name",
    name: "Должность",
  },
  {
    key: "secondary_email",
    name: "Почта",
  },
  {
    key: "phone",
    name: "Телефон",
  },
];

// Таблица с краткой инфой о сотруднике
const EmployeeFieldsTable = ({ data }) => {
  const columns = [
    {
      title: "Название поля",
      dataIndex: "name",
      width: "35%",
    },
    {
      title: "Значение поля",
      dataIndex: "value",
    },
  ];

  const tableData = FIELDS.map(({ key, name }) => ({
    key,
    name,
    value: data?.[key] || "-",
  }));

  return (
    <ConfigProvider
      theme={{
        components: {
          Table: {
            borderColor: "#E9E9E9",
            rowHoverBg: "#F8FBFF",
          },
        },
      }}
    >
      <Table
        showHeader={false}
        dataSource={tableData}
        columns={columns}
        pagination={false}
        showSorterTooltip={{
          target: "sorter-icon",
          title: "Нажмите для сортировки",
        }}
        size="small"
        scroll={{
          x: "100%",
        }}
        bordered
        className="striped-table"
        tableLayout="fixed"
        rowClassName="top-align"
      />
    </ConfigProvider>
  );
};

export default EmployeeFieldsTable;
